import { useHitsPerPage, useInstantSearch } from 'react-instantsearch'

import type { ReactElement } from 'react'
import type { UseHitsPerPageProps } from 'react-instantsearch'

import ShowItems from '~/components/ShowItems'

type Props = UseHitsPerPageProps & { entriesName: string }

const AlgoliaHitsPerPage = (props: Props): ReactElement => {
  /** Effects */

  const { refine } = useHitsPerPage(props)

  const { results } = useInstantSearch()

  /** Handlers */

  const handleSetNumberPerPage = (value: number) => refine(value)

  /** Render */

  return (
    <ShowItems
      entriesName={props.entriesName}
      numberPerPage={results.hitsPerPage}
      setNumberPerPage={handleSetNumberPerPage}
      totalNumberElements={results.nbHits}
    />
  )
}

export default AlgoliaHitsPerPage
